import {
    GlanceLoader,
  } from '../ui-components';
import React from 'react';

function LoadingState({gicon}) {

    return (
        <div className='SizeWrapper'>
            <div className='buttonAndTextWrapper'>
                <div className='rowAlign'>
                    { gicon && <div className='Spinner'>
                        <GlanceLoader size="12" spinning={true}></GlanceLoader> 
                      </div> }
                </div>
            </div>  
        </div>
        
        
    );
}

export default LoadingState;